import { render, staticRenderFns } from "./quick_related_columns.vue?vue&type=template&id=02575667&scoped=true&"
import script from "./quick_related_columns.vue?vue&type=script&lang=js&"
export * from "./quick_related_columns.vue?vue&type=script&lang=js&"
import style0 from "./quick_related_columns.vue?vue&type=style&index=0&id=02575667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02575667",
  null
  
)

export default component.exports